<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
        <vs-prompt
            title="New language"
            :accept-text="$t('Save')"
            :cancel-text="$t('Cancel')"
            @cancel="clearLanguageModal"
            @accept="SaveLanguage"
            @close="clearLanguageModal"
            :is-valid="validateLanguageForm"
            :active.sync="activePrompt">
                <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent style="max-height:75vh">
                        <label for="Language" class="vs-input--label">{{$t('Language')}}</label>
                                  <v-select
                                    label="Name"
                                    class="mt-5 w-full"
                                    v-model="language.Language"
                                    :options="languages"
                                    :reduce="Language => Language"
                                  />

                       <star-rating v-model="language.Level"
                       v-bind:star-size="30"
                       v-bind:show-rating="false"
                       ></star-rating>

                    </form>
                </VuePerfectScrollbar>
          </vs-prompt>

   <div>
    <div class="vx-row">

<div  class="vx-col lg:w-4/4 w-full">
      <vx-card title="Language" class="mb-base" >
          <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus" @click="activePrompt=true">{{$t('AddLanguage')}}</vs-button>

          <vs-table ref="table"   pagination :max-items="5"  :data="getListOfInstructorLanguage" >
            <template slot="thead">
              <vs-th >{{$t('Language')}} </vs-th>
              <vs-th >{{$t('Level')}}</vs-th>
              <vs-th>{{$t('Action')}}</vs-th>
            </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                       <p class="product-name font-medium truncate">{{ tr.Language.Name }}</p>
                    </vs-td>
                  <vs-td>
                   <star-rating v-model="tr.Level" :read-only="true"
                   v-bind:star-size="30"
                       v-bind:show-rating="false"></star-rating>
                           <div style="padding-top:10px;cursor:pointer;margin-bottom:20px;color: blue;"></div>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editLanguage(tr)" />
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="openConfirm(tr)" />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
          </vs-table>
      </vx-card>
</div>
</div>
    </div>
  </div>
</template>


<script>
import StarRating from 'vue-star-rating'
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";
export default {
  components:{
   StarRating,
   vSelect,
   VuePerfectScrollbar
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
       rating: "No Rating Selected",
      currentRating: "No Rating",
      currentSelectedRating: "No Current Rating",
      boundRating: 3,
       activePrompt:false,
      instructorModel: this.data,
       settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      language:{},
      dataForDeleted:{},
      edit:false,
      listOfInstructorLanguage:[],
    }
  },
  computed: {
    validateLanguageForm() {
      return this.language.Language!=undefined && this.language.Level>=0;
    },
    getListOfInstructorLanguage(){
      //return this.listOfInstructorLanguage
      return this.instructorModel.InstructorLanguages;
    },
    languages() {
      return this.$store.state.languageList.languages;
    }
  },
  methods: {
    setRating: function(rating) {
      this.rating = "You have Selected: " + rating + " stars";
    },
    showCurrentRating: function(rating) {
      this.currentRating = (rating === 0) ? this.currentSelectedRating : "Click to select " + rating + " stars"
    },
    setCurrentSelectedRating: function(rating) {
      this.currentSelectedRating = "You have Selected: " + rating + " stars";
    },
    SaveLanguage()
    {
      if(this.language.Level>0)
      {


        const isExist = this.instructorModel.InstructorLanguages.findIndex((p) => p.LanguageID == this.language.Language.ID);
        if(isExist>=0)
        {
         // this.colorAlert = color
            this.$vs.dialog({
                color: "warning",
                title: this.$t("Dialogwarning"),
              text: this.$t("ThisLanguageAlreadyExists"),
            })
            this.language={};
            return;
        }
         if(this.edit)
          {
              this.deleteLanguage(this.dataForDeleted);
              this.edit=false;
          }
          this.language.LanguageID=this.language.Language.ID;
         // this.deleteLanguage(this.language);
          this.listOfInstructorLanguage.push(this.language);
          this.instructorModel.InstructorLanguages=  this.listOfInstructorLanguage;
          //this.deletefacility(this.facility);
         // this.$store.commit("classRoomList/ADD_Facility", this.facility);
          this.clearLanguageModal();
           }
    },

     clearLanguageModal() {
      this.language = {}
    },

    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm") ,
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlert
      });
    },
     acceptAlert() {
    debugger;
      this.deleteLanguage(this.rowDataForDelete);
      this.$vs.notify({
        color: "danger",
        title:this.$t("Deletedrecord"),
          text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    deleteLanguage(data) {
      debugger;
      if(data.ID>0)
      {
         this.$store.dispatch("instructorList/removeLanguage",  data.ID);
      }
      debugger;
    const ItemIndex = this.instructorModel.InstructorLanguages.findIndex((p) => p.LanguageID == data.LanguageID)
     //if(ItemIndex!=-1)
          this.instructorModel.InstructorLanguages.splice(ItemIndex, 1)
    },
    editLanguage(data){
    this.edit=true;
       this.language = JSON.parse(JSON.stringify(data));
       this.dataForDeleted=this.language;
       this.activePrompt=true;

    },
  },
  created(){
    debugger;
     if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }
    this.$store.dispatch("languageList/fetchDataListItems");
    if(this.instructorModel.InstructorLanguages.length>0)
    {
     this.listOfInstructorLanguage= this.instructorModel.InstructorLanguages;
    }

  }
}
</script>
